<template>
  <div v-if="show" class="keypad-overlay">
    <div class="keypad-card">

      <div class="keypad-header">

        <div v-if="tablet_auth" class="message-container" :style="{ fontSize: (default_font_size * 1.1) + 'em' }">
          {{ $t('dialog.point_save_question') }}<br/>
          {{ $t('dialog.enter_phone') }}
        </div>

        <div v-else class="message-container" :style="{ fontSize: (default_font_size * 1.1) + 'em' }">

          <template v-if="message == 'start_tablet_order2'">
            {{ $t('dialog.manage_order_phone') }}<br/>
            <span class="highlight-text">{{ $t('dialog.enter_phone') }}</span><br/>
            <span class="sub-text">{{ $t('dialog.order_status_sent') }}</span>
          </template>

          <template v-else-if="message == 'set_passnumber'">
            <div class="highlight-box">{{ $t('enter_table_password1') }}</div>
            <div class="highlight-box mt-2">{{ $t('enter_table_password2') }}</div>
            <div class="small-text mt-2">{{ $t('enter_table_password3') }}</div>
          </template>

          <template v-else-if="message == 'change_phonenumber'">
            <div class="highlight-box">{{ $t('dialog.enter_phone') }}</div>
          </template>

          <template v-else-if="message == 'set_phonenumber'">
            <div class="highlight-box">{{ $t('dialog.enter_phone') }}</div>
          </template>

          <div v-if="mode == 'phone'" class="noti-check-area">
          </div>
        </div>

        <div class="number-display-wrapper">
          <div class="number-display" :style="{ fontSize: (default_font_size * 1.5) + 'em' }">
            <span v-if="phone_number" v-html="phone_number"></span>
            <span v-else class="placeholder">&nbsp;</span>
          </div>
        </div>

      </div>

      <div class="keypad-body">
        <div class="keypad-grid">
          <button class="key-btn" @click="add('1')">1</button>
          <button class="key-btn" @click="add('2')">2</button>
          <button class="key-btn" @click="add('3')">3</button>

          <button class="key-btn" @click="add('4')">4</button>
          <button class="key-btn" @click="add('5')">5</button>
          <button class="key-btn" @click="add('6')">6</button>

          <button class="key-btn" @click="add('7')">7</button>
          <button class="key-btn" @click="add('8')">8</button>
          <button class="key-btn" @click="add('9')">9</button>

          <div class="key-empty"></div>

          <button class="key-btn" @click="add('0')">0</button>

          <button class="key-btn key-backspace" @click="backspace()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="24" height="24">
              <path d="M576 128c0-35.3-28.7-64-64-64H205.3c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l150.6 150.6c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64V128zM271 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/>
            </svg>
          </button>
        </div>

        <div class="extra-options-area">
          <template v-if="tablet_auth">
            <div class="info-text">{{ $t('dialog.number_saved_info') }}</div>
          </template>

          <template v-else>
            <div v-if="mode == 'pass'" class="change-mode-wrapper" @click="set_phonenumber_force">
              <button v-if="!only_pass" class="btn-text-mode">
                {{ $t('dialog.manage_order_phone') }}
              </button>
            </div>

            <div v-else class="change-mode-wrapper" @click="set_passnumber">
              <div class="info-text mb-1">{{ $t('dialog.no_phone_manage_order') }}</div>
              <button class="btn-text-mode">
                {{ $t('dialog.manage_order_password') }}
              </button>
            </div>
          </template>

          <div v-if="!tablet_auth && !no_point && mode == 'phone'" class="point-check-wrapper">
            <div class="check-box">
              <my-check v-model="point" :label="$t('dialog.earn_store_points')" id="point"/>
            </div>
            <button class="btn-mini" @click="detail = !detail">{{ $t('dialog.more_info') }}</button>
          </div>

          <div v-if="detail" class="detail-info-box">
            {{ $t('dialog.details') }}
          </div>
        </div>
      </div>

      <div class="keypad-footer">
        <template v-if="tablet_auth">
          <button class="action-btn btn-cancel" @click="without_point()">
            {{ $t('dialog.dont_earn_points') }}
          </button>
          <button class="action-btn btn-confirm" @click="check_num()">
            {{ $t('dialog.continue') }}
          </button>
        </template>

        <template v-else>
          <button class="action-btn btn-cancel" @click="cancel()">
            {{ $t('dialog.cancel') }}
          </button>
          <button class="action-btn btn-confirm" @click="check_num()">
            {{ $t('dialog.confirm') }}
          </button>
        </template>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MyCheck from "../form/MyCheck2.vue";

export default {
  name: "NumericKeypadTablet",
  components: { MyCheck },
  computed: mapGetters({
    offline_info: 'offline_info',
    lang_current_code: 'lang_current_code',
    torder_no: 'torder_no',
    prepay: 'prepay',
    tablet_prepay: 'tablet_prepay',
    tablet_auth: 'tablet_auth',
    shop_uid: 'shop_uid',
    default_font_size: 'default_font_size',
    pay_type: 'pay_type',
    cart_items: 'cart_items',
    pay_amount: 'pay_amount',
    kiosk_host: 'kiosk_host',
    touchable: 'touchable',
    point_num: 'point_num',
    receipt_num: 'receipt_num'
  }),
  data: () => ({
    only_pass: false,
    order_noti: false,
    point: true,
    num_type: '',
    show: false,
    detail: false,
    message: '',
    phone_number: '010',
    phone_number_only: '',
    no_point: false,
    change_mode: false,
    smart_order: false,
    cancel_txt: '',
    json_data: {},
    mode: 'phone'
  }),
  watch: {
    phone_number: {
      handler() {
        this.phone_number = this.phoneNumber(this.phone_number)
      },
    },
  },
  beforeUnmount() {
    this.emitter.off('enter_phone_num_table_order')
    this.emitter.off('change_phone_num_table_order')
    this.emitter.off('enter_phone_num_tablet_order')
  },
  mounted() {
    this.cancel_txt = this.$t('dialog.cancel')
    this.emitter.on('enter_phone_num_tablet_order', this.start_tablet_order)
    this.emitter.on('enter_phone_num_table_order', this.set_phonenumber)
    this.emitter.on('change_phone_num_table_order', this.change_phonenumber)
  },
  methods: {
    // ... 기존 비즈니스 로직 그대로 유지 ...
    start_tablet_order() {
      var url = '/torder-api/tableorder/table/tablet?table_no=' + this.torder_no
      this.$http.get(url).then(res => {
        try {
          var o = res.data.table_info
          if (o.phone_number) {
            if(this.tablet_prepay) {
              this.emitter.emit("tablet_order_request_prepay", null)
            } else {
              this.emitter.emit("tablet_order_start", null)
            }
          } else {
            this.start_tablet_order2()
          }
        } catch (e) {
          this.start_tablet_order2()
        }
      }).catch(err => {
        try {
          if (err.data.errorMessage.indexOf("ERR302") >= 0) {
            this.start_tablet_order2()
            return
          }
        } catch (e) {}
        if(this.tablet_prepay) {
          this.emitter.emit("tablet_order_request_prepay", null)
        } else {
          this.emitter.emit("tablet_order_start", null)
        }
      })
    },
    start_tablet_order2() {
      this.no_point = false
      this.cancel_txt = this.$t('dialog.cancel')
      this.message = 'start_tablet_order2'
      this.phone_number = '010'
      this.mode = 'phone'
      this.show = true
    },
    set_passnumber() {
      this.cancel_txt = this.$t('dialog.cancel')
      this.message = 'set_passnumber'
      this.mode = 'pass'
      this.phone_number = ''
      var v = this.$cookie.getCookie2('mypass_number')
      if (v) this.phone_number = v
      this.show = true
    },
    change_phonenumber() {
      this.change_mode = true
      this.cancel_txt = this.$t('dialog.cancel')
      this.message = 'change_phonenumber'
      this.phone_number = '010'
      this.mode = 'phone'
      var v = this.$cookie.getCookie2('myphone_number')
      if (v) this.phone_number = v
      this.show = true
    },
    set_phonenumber_force(no_point) {
      let only_pass = false
      if(this.offline_info && this.offline_info.sale_ref) {
        try {
          let a = JSON.parse(this.offline_info.sale_ref)
          if(a.only_pass) {
            only_pass = true
            this.only_pass = true
          }
        } catch (e) {}
      }
      if(only_pass) {
        this.set_passnumber()
        return
      }
      this.no_point = no_point ? true : false
      this.change_mode = false
      this.cancel_txt = this.$t('dialog.cancel')
      this.message = 'set_phonenumber'
      this.phone_number = '010'
      this.mode = 'phone'
      var v = this.$cookie.getCookie2('myphone_number')
      if (v) this.phone_number = v
      this.show = true
    },
    set_phonenumber(no_point) {
      let only_pass = false
      if(this.offline_info && this.offline_info.sale_ref) {
        try {
          let a = JSON.parse(this.offline_info.sale_ref)
          if(a.only_pass) {
            only_pass = true
            this.only_pass = true
          }
        } catch (e) {}
      }
      if(only_pass) {
        this.set_passnumber()
        return
      }
      if(this.lang_current_code != 'ko') {
        this.set_passnumber()
        return;
      }
      this.no_point = no_point ? true : false
      this.change_mode = false
      this.cancel_txt = this.$t('dialog.cancel')
      this.message = 'set_phonenumber'
      this.phone_number = '010'
      this.mode = 'phone'
      var v = this.$cookie.getCookie2('myphone_number')
      if (v) this.phone_number = v
      this.show = true
    },
    add(num) {
      if (this.mode == 'pass' && this.phone_number.length >= 4) return
      var pn = this.phone_number.length
      if (pn >= 17) return
      this.phone_number += num
    },
    phoneNumber(value) {
      if (this.mode == 'pass') return value
      if (!value) return "";
      value = value.replace(/[^0-9]/g, "");
      this.phone_number_only = value;
      let result = [];
      let restNumber = "";
      if (value.startsWith("02")) {
        result.push(value.substr(0, 2));
        restNumber = value.substring(2);
      } else if (value.startsWith("1")) {
        restNumber = value;
      } else {
        result.push(value.substr(0, 3));
        restNumber = value.substring(3);
      }
      if (restNumber.length === 7) {
        result.push(restNumber.substring(0, 3));
        result.push(restNumber.substring(3));
      } else {
        result.push(restNumber.substring(0, 4));
        result.push(restNumber.substring(4));
      }
      return result.filter((val) => val).join(" - ");
    },
    backspace() {
      this.phone_number = this.phone_number.slice(0, -1)
    },
    numValidation() {
      let number = this.phone_number_only
      var regExp = /^(?:(010\d{4})|(01[1|6|7|8|9]\d{3,4}))(\d{4})$/;
      if (!regExp.test(number)) return false
      return true
    },
    without_point() {
      if (this.tablet_prepay) {
        this.emitter.emit("tablet_order_request_prepay", null)
      } else {
        this.emitter.emit("tablet_order_start", null)
      }
      this.show = false
    },
    check_num() {
      if (this.mode != 'pass' && this.numValidation() == false) {
        this.$toast.error(this.$t('invalid_phone_number'), { position: "top" })
        return
      } else if (this.mode == 'pass' && this.phone_number.length < 4) {
        this.$toast.error(this.$t('dialog.enter_4_digits'), { position: "top" })
        return
      }
      if (this.tablet_auth) {
        if (this.tablet_prepay) {
          this.emitter.emit("tablet_order_request_prepay", this.phone_number)
        } else {
          this.emitter.emit("tablet_order_start", this.phone_number)
        }
        this.show = false
        return
      }
      if (this.change_mode) {
        this.show = false
        this.emitter.emit("change_phone_num_table_order_callback", {
          pass: this.phone_number,
          earn_point: this.point
        })
        return
      }
      if (this.mode == 'pass') {
        this.$cookie.setCookie365('mypass_number', this.phone_number)
        this.$cookie.setCookie365('mypass_type', 'pass')
        this.$store.commit('torder_pass', { value: this.phone_number })
        this.$store.commit('torder_type', { value: 'pass' })
      } else if (this.mode == 'phone') {
        this.$cookie.setCookie365('myphone_number', this.phone_number_only)
        this.$cookie.setCookie365('mypass_type', 'phone')
        this.$store.commit('torder_phone', { value: this.phone_number_only })
        this.$store.commit('torder_type', { value: 'phone' })
      }
      this.$store.commit('earn_point', { value: this.point })
      this.show = false
      this.emitter.emit("order_noti", this.order_noti)
      this.emitter.emit("torder_ok")
    },
    cancel() {
      this.show = false
    }
  }
}
</script>

<style scoped>
/* 오버레이: 전체 화면 */
.keypad-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex; align-items: center; justify-content: center;
  z-index: 1000;
  padding: 10px;
  box-sizing: border-box;
}

/* 카드 컨테이너 */
.keypad-card {
  background: #fff;
  width: 100%;
  max-width: 420px;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  display: flex; flex-direction: column;
  overflow: hidden;
  max-height: 95vh;
}

/* 1. 헤더 영역 */
.keypad-header {
  padding: 24px 20px 10px;
  text-align: center;
  background-color: #fff;
  flex-shrink: 0;
}

.message-container {
  margin-bottom: 15px;
  color: #333;
  line-height: 1.4;
}

.highlight-text {
  font-size: 1.3em;
  font-weight: bold;
  color: #000;
}

.sub-text {
  color: #666;
  font-size: 0.9em;
  margin-top: 5px; display: block;
}

/* 박스 형태의 강조 텍스트 */
.highlight-box {
  display: inline-block;
  font-size: 1.2em;
  font-weight: 600;
  padding: 2px 4px;
  box-shadow: inset 0 -8px 0 #bfffa1;
}

.small-text {
  font-size: 0.85em; color: #888;
}
.mt-2 { margin-top: 8px; }
.mb-1 { margin-bottom: 4px; }

/* 입력값 표시 영역 */
.number-display-wrapper {
  display: flex; justify-content: center;
}

.number-display {
  display: inline-block;
  min-width: 80%;
  padding: 8px 0;
  font-weight: bold;
  color: var(--qro-primary-color, #250063);
  border-bottom: 2px solid var(--qro-primary-color, #250063);
  text-align: center;
  letter-spacing: 0.5px;
}
.placeholder { color: transparent; }

/* 2. 바디 영역 */
.keypad-body {
  padding: 10px 20px;
  display: flex; flex-direction: column;
  align-items: center;
  flex: 1;
  overflow-y: auto; /* 내용 많을 시 스크롤 */
}

.keypad-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  width: 100%;
  max-width: 320px;
}

/* 키 버튼 스타일 */
.key-btn {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  color: var(--qro-primary-color, #250063);
  font-size: 1.5em;
  font-weight: bold;
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: background-color 0.1s;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  height: 52px;
  width: 100%;
}
.key-btn:active {
  background-color: #f0f0f0;
  transform: translateY(1px);
}
.key-backspace svg {
  fill: var(--qro-primary-color, #250063);
}
.key-empty { visibility: hidden; }

/* 추가 옵션 영역 (모드 변경, 체크박스 등) */
.extra-options-area {
  width: 100%;
  margin-top: 20px;
  display: flex; flex-direction: column; align-items: center;
}

.info-text {
  color: #666; font-size: 0.95em;
}

.change-mode-wrapper {
  margin-top: 10px;
  text-align: center;
  cursor: pointer;
}

.btn-text-mode {
  background: #f1f3f5;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  color: #555;
  font-weight: 500;
  font-size: 0.9em;
  cursor: pointer;
}

.point-check-wrapper {
  margin-top: 15px;
  display: flex; align-items: center;
  width: 100%; max-width: 280px;
}
.check-box { flex-grow: 1; font-size: 1.05em; }

.btn-mini {
  font-size: 0.8em;
  background-color: var(--qro-secondary-color, #888);
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  margin-left: 8px;
  white-space: nowrap;
}

.detail-info-box {
  width: 100%; max-width: 280px;
  margin-top: 10px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  font-size: 0.9em; color: #555;
}

/* 3. 푸터 영역 */
.keypad-footer {
  padding: 15px 20px 20px;
  display: flex; gap: 10px;
  flex-shrink: 0;
  background-color: #fff;
}

.action-btn {
  flex: 1;
  padding: 14px 0;
  border-radius: 8px;
  border: none;
  font-size: 1.1em;
  font-weight: bold;
  cursor: pointer;
  transition: opacity 0.2s;
  height: 52px;
}

.btn-cancel {
  background-color: #f1f3f5; color: #495057;
}
.btn-confirm {
  background-color: var(--qro-primary-color, #250063); color: #fff;
}
.action-btn:active { opacity: 0.8; }

/* 미디어 쿼리 (화면 높이가 작을 때) */
@media (max-height: 600px) {
  .keypad-header { padding: 10px 20px 5px; }
  .keypad-body { padding: 5px 20px; }
  .keypad-grid { gap: 6px; max-width: 360px; }
  .key-btn { height: 42px; font-size: 1.3em; }
  .keypad-footer { padding: 8px 20px 10px; }
  .action-btn { height: 42px; font-size: 1em; }
  .extra-options-area { margin-top: 10px; }
}
</style>